import React, { useCallback, useState, memo } from 'react';
import { useSelector } from 'react-redux';

import Button from 'common/Button/Button';
import { CheckBoxInput, InputBox, SelectBox } from 'common/FormField/formField';
import Loader from 'common/Loader/Loader';
import { FlexDiv, GenericDiv, GenericP, GenericSpan, Heading, VerticalCentreAligDiv } from 'commonStyles';
import { CommentField, MICE_MODAL_HEADING, MICE_SERVICES } from '../../config';
import { MiceContainerWrapper, MiceFormWrap, MiceModalWrapper, QuoteImageBox } from './MiceFormStyles';
import { checkForError } from 'UtilityComponents/miceUtils';
import { processImgParams } from 'UtilityComponents/Util';
import PriceComponent from '../HotelSearch/components/PriceComponent/PriceComponent';

const GetQuoteForm = ({ isMobile, handleSubmit, formFields = [], showLoader }) => {
	const [isDisabled, setDisabled] = useState(true);
	const modalData = useSelector((state) => state.mice.modalData);
	const { selectedHotelData } = modalData;
	const { images, name, area, bestPoi, isDropQuery } = selectedHotelData;

	const onChangeInput = useCallback(() => {
		const anyError = checkForError(formFields);
		setDisabled(anyError);
	}, [isDisabled]);

	const disableClass = showLoader ? 'disabledwithLoader' : '';
	const btnText = showLoader ? (<Loader margin='0' color='#fff' size='9' />) : 'SUBMIT';

	const checkChange = useCallback((field) => {
		if (field.value === true) {
			formFields.push(CommentField);
		} else {
			formFields.splice(-1);
		}
		setNotes(field.value);
	}, [formFields]);

	const getFields = (field) => {
		switch (field.type) {
			case 'text':
			case 'email':
			case 'tel':
			case 'textArea':
				return <InputBox handleChange={onChangeInput} key={field.name} field={field} />;
			case 'select':
				return (<SelectBox onChange={onChangeInput} field={field} />
				);
			case 'checkbox':
				return (
					<FlexDiv key={field.name} directionInMobile='column' color='#4A4A4A' bottom_M='16' fsize='14' f_weight='700' justify='space-between' left_P='-12'>
						<GenericP right_M='10' f_weight='700' bottom_M={isMobile && '12'}>{MICE_SERVICES}</GenericP>
						<CheckBoxInput
							field={field}
							key={field.name}
							onChange={onChangeInput}
						/>
					</FlexDiv>
				);
			default:
				return <GenericDiv key={field.name} top_M={isMobile ? '10' : isDropQuery ? '20' : '12'} fsize='14' color='#4A4A4A' bottom_M='12'>{field.content}</GenericDiv>;
		};
	};

	return (
		<MiceModalWrapper className={isDropQuery ? 'drop-query' : 'get-quote'}>
			{(!isMobile || !isDropQuery) &&
				<MiceContainerWrapper>
					{!isMobile && <Heading as='h3' font_size='26'>{MICE_MODAL_HEADING}</Heading>}
					<VerticalCentreAligDiv top_M={isDropQuery && '16'} bg='linear-gradient(#f3f3f3, #f3f3f3)'>
						{images && images.length > 0 &&
							<QuoteImageBox src={processImgParams(images[0], isMobile, { ratio: 2.2, initWidth: 1000 })} alt={name} />}
						<FlexDiv width='auto' direction='column' directionInMobile='column'>
							{name &&
								<GenericP color='#FF664B' f_weight='400'>{name}
									<GenericSpan>{area && `, ${area}`}</GenericSpan>
								</GenericP>}
							{bestPoi && <GenericP fsize='12px' color='#9B9B9B'>{bestPoi}</GenericP>}
							{isMobile &&
								<GenericDiv top_M='12'>
									<PriceComponent item={selectedHotelData} isMobile={isMobile} />
								</GenericDiv>}
						</FlexDiv>
						{!isMobile &&
							<GenericDiv width='160px'>
								<PriceComponent item={selectedHotelData} display='block' />
							</GenericDiv>}
					</VerticalCentreAligDiv>
				</MiceContainerWrapper>}
			<MiceFormWrap bg='linear-gradient(#f3f3f3, #f3f3f3);' onSubmit={handleSubmit}>
				{formFields.map((field) => getFields(field))}
				<Button
					btnTxt={btnText}
					disableClass={disableClass}
					btnType='Flat'
					btnName='Primary'
					btnShadow
					btnWidth='100%'
					height='44px'
					type='submit'
					disabled={isDisabled || showLoader}
				/>
			</MiceFormWrap>
		</MiceModalWrapper>
	);
};

export default memo(GetQuoteForm);
